function formatDate(value, options = {}) {
    if (!value) return '-';

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '-';

    const {
        locale = 'ru-RU',
        timeZone = 'UTC',
        withTime = true,
        withSeconds = false,
    } = options;

    const formatOptions = withTime
        ? {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            ...(withSeconds ? { second: '2-digit' } : {}),
            timeZone,
        }
        : {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            timeZone,
        };

    return new Intl.DateTimeFormat(locale, formatOptions).format(date);
}

export default formatDate;